export const BREAKPOINT = {
  mobileMin: 360,
  mobileMax: 599,
  tabletMin: 600,
  tabletMax: 1499,
  pc: 1500,
};
